import React from 'react'

import {
  BrowserRouter as Router,
  Route,
  Switch,
} from 'react-router-dom'

import {
  map,
  defaults,
} from 'lodash'

import redirect from './redirect'

import LoginPage from '../../pages/LoginPage'
import AdminPage from '../../pages/AdminPage'
import SignUpPage from '../../pages/SignUpPage'
import ForgotMyPasswordPage from '../../pages/ForgotMyPasswordPage'
import RecoveryPage from '../../pages/RecoveryPage'
// import LandingPage from '../../pages/LandingPage'

const routes = {
  all: [
    { path: '/', redirect: '/login', },
  ],
  unauthenticated: [
    { path: '/login', component: LoginPage },
    { path: '/signup', component: SignUpPage },
    { path: '/forgot-my-password', component: ForgotMyPasswordPage },
    { path: '/recovery', component: RecoveryPage },
  ],
  authenticated: [
    { path: '/admin', redirect: '/admin/surveys' },
    { path: '/admin/surveys', render: () => <AdminPage menu="surveys" /> },
    { path: '/admin/users', render: () => <AdminPage menu="users" /> },
    { path: '/admin/comments', render: () => <AdminPage menu="comments" /> },
  ],
}

function Routes() {
  const routesToRender = [
    ...routes.authenticated,
    ...routes.unauthenticated,
    ...routes.all
  ]

  return (
    <Router>
      <Switch>
        {
          map(routesToRender, (route, i) => {
            let routeProps = defaults({}, route, { key: i, exact: true })
            if (route.redirect) {
              routeProps.component = redirect(route.redirect)
            }

            return <Route { ...routeProps } />
          })
        }
      </Switch>
    </Router>
  )
}

export default Routes
